// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SavedChats_savedChatsContainer__-ywsw {
        padding: 50px; /* Adjust padding as needed */
        margin: 0 auto; /* Center the container */
        max-width: 1200px; /* Set a maximum width for better layout */
        box-sizing: border-box; /* Ensure padding doesn't affect width */
        padding-top: 90px;    
}

.SavedChats_actionButtons__OaadO > button {
    margin-right: 8px;
}

.SavedChats_actionButtons__OaadO > button:last-child {
    margin-right: 0; /* Remove margin for the last button */
}

.SavedChats_btnOptions__wT\\+mv {
    display: flex; /* Align buttons horizontally */
    flex-direction: row; /* Ensure horizontal layout */
    gap: 8px; /* Add spacing between buttons */
    align-items: right; /* Center buttons vertically */
    padding: 10px 0; /* Adjust padding as needed */
    margin-left: auto; /* Push buttons to the right */
    margin-right: 16px; /* Add space from the right side */
}

.SavedChats_btnOptions__wT\\+mv > span {
    display: flex; /* Ensure spans containing buttons are also aligned horizontally */
    align-items: center;
}

.SavedChats_btnOptions__wT\\+mv button {
    background: none;
    border: 1px solid #ccc; /* Add a light gray border */
    border-radius: 4px; /* Optional: Add rounded corners */
    padding: 4px 8px; /* Adjust padding for better appearance */
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s, border-color 0.2s; /* Add hover transition */
}

.SavedChats_btnOptions__wT\\+mv button:hover {
    background-color: #f0f0f0; /* Add a light background on hover */
    border-color: #999; /* Darken the border on hover */
}

.SavedChats_btnOptions__wT\\+mv button:focus {
    outline: none; /* Remove default focus outline */
    border-color: #0078d4; /* Highlight border on focus */
    box-shadow: 0 0 4px #0078d4; /* Optional: Add a focus shadow */
}

.SavedChats_btnOptions__wT\\+mv button > img{
    height: 16px;
    width: 16px;
}

.SavedChats_moreOptions__iJO9p {
    bottom: -6px;
    height: 10px;
    width: 10px;
    right: 35px;
}

.SavedChats_moreOptions__iJO9p:focus {
    outline: none;
}

.SavedChats_menuGrid__xlrcI{
    font-size: 12;
    margin-right: -20px;
    &:hover {
        backgroundColor: '#f0f0f0',
      }
}

.SavedChats_menuGridLine__jJiVh{
    font-size: 12;
    &:hover {
        backgroundColor: '#f0f0f0',
      }
}`, "",{"version":3,"sources":["webpack://./src/Pages/SavedChats/SavedChats.module.css"],"names":[],"mappings":"AAAA;QACQ,aAAa,EAAE,6BAA6B;QAC5C,cAAc,EAAE,yBAAyB;QACzC,iBAAiB,EAAE,0CAA0C;QAC7D,sBAAsB,EAAE,wCAAwC;QAChE,iBAAiB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe,EAAE,sCAAsC;AAC3D;;AAEA;IACI,aAAa,EAAE,+BAA+B;IAC9C,mBAAmB,EAAE,6BAA6B;IAClD,QAAQ,EAAE,gCAAgC;IAC1C,kBAAkB,EAAE,8BAA8B;IAClD,eAAe,EAAE,6BAA6B;IAC9C,iBAAiB,EAAE,8BAA8B;IACjD,kBAAkB,EAAE,kCAAkC;AAC1D;;AAEA;IACI,aAAa,EAAE,kEAAkE;IACjF,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB,EAAE,4BAA4B;IACpD,kBAAkB,EAAE,kCAAkC;IACtD,gBAAgB,EAAE,yCAAyC;IAC3D,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oDAAoD,EAAE,yBAAyB;AACnF;;AAEA;IACI,yBAAyB,EAAE,oCAAoC;IAC/D,kBAAkB,EAAE,+BAA+B;AACvD;;AAEA;IACI,aAAa,EAAE,iCAAiC;IAChD,qBAAqB,EAAE,8BAA8B;IACrD,2BAA2B,EAAE,iCAAiC;AAClE;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;QACI;MACF;AACN;;AAEA;IACI,aAAa;IACb;QACI;MACF;AACN","sourcesContent":[".savedChatsContainer {\n        padding: 50px; /* Adjust padding as needed */\n        margin: 0 auto; /* Center the container */\n        max-width: 1200px; /* Set a maximum width for better layout */\n        box-sizing: border-box; /* Ensure padding doesn't affect width */\n        padding-top: 90px;    \n}\n\n.actionButtons > button {\n    margin-right: 8px;\n}\n\n.actionButtons > button:last-child {\n    margin-right: 0; /* Remove margin for the last button */\n}\n\n.btnOptions {\n    display: flex; /* Align buttons horizontally */\n    flex-direction: row; /* Ensure horizontal layout */\n    gap: 8px; /* Add spacing between buttons */\n    align-items: right; /* Center buttons vertically */\n    padding: 10px 0; /* Adjust padding as needed */\n    margin-left: auto; /* Push buttons to the right */\n    margin-right: 16px; /* Add space from the right side */\n}\n\n.btnOptions > span {\n    display: flex; /* Ensure spans containing buttons are also aligned horizontally */\n    align-items: center;\n}\n\n.btnOptions button {\n    background: none;\n    border: 1px solid #ccc; /* Add a light gray border */\n    border-radius: 4px; /* Optional: Add rounded corners */\n    padding: 4px 8px; /* Adjust padding for better appearance */\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.2s, border-color 0.2s; /* Add hover transition */\n}\n\n.btnOptions button:hover {\n    background-color: #f0f0f0; /* Add a light background on hover */\n    border-color: #999; /* Darken the border on hover */\n}\n\n.btnOptions button:focus {\n    outline: none; /* Remove default focus outline */\n    border-color: #0078d4; /* Highlight border on focus */\n    box-shadow: 0 0 4px #0078d4; /* Optional: Add a focus shadow */\n}\n\n.btnOptions button > img{\n    height: 16px;\n    width: 16px;\n}\n\n.moreOptions {\n    bottom: -6px;\n    height: 10px;\n    width: 10px;\n    right: 35px;\n}\n\n.moreOptions:focus {\n    outline: none;\n}\n\n.menuGrid{\n    font-size: 12;\n    margin-right: -20px;\n    &:hover {\n        backgroundColor: '#f0f0f0',\n      }\n}\n\n.menuGridLine{\n    font-size: 12;\n    &:hover {\n        backgroundColor: '#f0f0f0',\n      }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"savedChatsContainer": `SavedChats_savedChatsContainer__-ywsw`,
	"actionButtons": `SavedChats_actionButtons__OaadO`,
	"btnOptions": `SavedChats_btnOptions__wT+mv`,
	"moreOptions": `SavedChats_moreOptions__iJO9p`,
	"menuGrid": `SavedChats_menuGrid__xlrcI`,
	"menuGridLine": `SavedChats_menuGridLine__jJiVh`
};
export default ___CSS_LOADER_EXPORT___;
